import React, { FC, useMemo, useRef, useState } from 'react';

//devextreem
import Form, { Item, RequiredRule } from 'devextreme-react/form';
import { Popup } from 'devextreme-react/popup';
import { DropDownOptions } from 'devextreme-react/select-box';
import ValidationGroup from 'devextreme-react/validation-group';
import Validator from 'devextreme-react/validator';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import ModalFooter from 'components/appModalFooter';
import { DateBox, SelectBox, TextArea } from 'devextreme-react';
import $createDataSource from 'utils/create-data-souce-instance';
import { isSuccess } from 'utils/responseStatus';

import {
  useCreateEmployeeSalaryAdjustmentsMutation,
  useEditEmployeeSalaryAdjustmentsMutation,
  useLazyGetEmployeeSalaryAdjustmentsQuery,
} from 'bus/employeeSalaryAdjustments/employeeSalaryAdjustments';
import { EmployeeSalaryAdjustmentsItem } from 'bus/employeeSalaryAdjustments/types';

import { getDefaultFilter } from '../../utils';

type CreateEditModalProps = {
  visible: boolean;
  changeVisible: (visible: boolean) => void;
  refresh: () => void;
  id: number | null;
  type: 'driver' | 'mixer' | 'employee';
};

const initialForm: EmployeeSalaryAdjustmentsItem = {
  id: null,
  comment: '',
  date: '',
  driverId: null,
};

const CreateEditModal: FC<CreateEditModalProps> = ({ changeVisible, refresh, visible, id, type }) => {
  const [createAdjustment, { isLoading: isCreateLoading }] = useCreateEmployeeSalaryAdjustmentsMutation();
  const [editAdjustment, { isLoading: isEditLoading }] = useEditEmployeeSalaryAdjustmentsMutation();
  const [getAdjustment] = useLazyGetEmployeeSalaryAdjustmentsQuery();
  //const { data: adjustmentData } = useSelector((store: RootStore) => store.employeeSalaryAdjustments.detail);

  let createGroupValidationRef = useRef<ValidationGroup>(null);

  const [form, setForm] = useState<EmployeeSalaryAdjustmentsItem>(initialForm);
  const storeEmployee: any = useMemo(() => {
    const defaultFilter = getDefaultFilter(type);

    const defaultSort = [{ selector: 'fullName', desc: false }];
    return $createDataSource('/v1/employee', 'id', { defaultFilter, defaultSort });
  }, [type]);

  const onShown = async () => {
    if (id) {
      const res = await getAdjustment({ id });
      if (isSuccess(res)) {
        const data: any = 'data' in res ? (res as any).data : (res as any);
        setForm(data);
      }
    } else {
      setForm(initialForm);
    }
  };

  const onHidden = () => {
    setForm(initialForm);
    createGroupValidationRef.current?.instance.reset();
  };

  const handleSubmit = async (e: any) => {
    e.preventDefault && e.preventDefault();

    if (createGroupValidationRef.current?.instance.validate().isValid) {
      if (id) {
        editAdjustment(form as any).then((res: any) => {
          if (isSuccess(res)) {
            changeVisible(false);
            refresh();
          }
        });
      } else {
        const temp = { ...form };
        delete (temp as any).id;
        createAdjustment(temp as any).then((res: any) => {
          if (isSuccess(res)) {
            changeVisible(false);
            refresh();
          }
        });
      }
    }
  };

  return (
    <div>
      <Popup
        visible={visible}
        onHiding={() => changeVisible(false)}
        dragEnabled={true}
        closeOnOutsideClick={false}
        showTitle={true}
        title="Корректировка"
        width={500}
        onShowing={onShown}
        onHidden={onHidden}
        height="auto"
      >
        <div className="modal-block">
          <div className="modal-block__content">
            <form onSubmit={handleSubmit}>
              <ValidationGroup ref={createGroupValidationRef}>
                <Form id="test-facrory" formData={form}>
                  <Item colSpan={12} colCount={12} itemType="group">
                    <AppRow>
                      <AppGroup col={12}>
                        <AppFiledBox label="Дата" labelTop>
                          <DateBox
                            stylingMode="underlined"
                            type="date"
                            onValueChange={(e) => {
                              setForm((prev) => ({ ...prev, date: e as string }));
                            }}
                            useMaskBehavior
                            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
                            value={form.date}
                          >
                            <Validator>
                              <RequiredRule message="Заполните поле дата" />
                            </Validator>
                          </DateBox>
                        </AppFiledBox>
                        <AppFiledBox label={type === 'employee' ? 'Контрагент' : 'Водитель'} labelTop>
                          <SelectBox
                            stylingMode="underlined"
                            dataSource={storeEmployee}
                            displayExpr="fullName"
                            valueExpr="id"
                            value={form.driverId}
                            searchEnabled
                            onItemClick={(e) => {
                              setForm((prev) => ({ ...prev, driverId: e.itemData.id }));
                            }}
                          >
                            <DropDownOptions title="Выберите Водитель" closeOnOutsideClick={true} showTitle={false} />
                            <Validator>
                              <RequiredRule message="Выберите Водитель" />
                            </Validator>
                          </SelectBox>
                        </AppFiledBox>

                        <AppFiledBox label="Комментарий" labelTop>
                          <TextArea
                            stylingMode="underlined"
                            placeholder="Введите комментарий"
                            mode="text"
                            value={form.comment || ''}
                            onChange={(e: any) => {
                              setForm((prev) => ({ ...prev, comment: e.event.currentTarget.value }));
                            }}
                          />
                        </AppFiledBox>
                      </AppGroup>
                    </AppRow>
                  </Item>
                </Form>
                <ModalFooter
                  useSubmitBehavior={false}
                  handleSubmit={handleSubmit}
                  hideModal={() => changeVisible(false)}
                  disabledSubmit={isCreateLoading || isEditLoading}
                />
              </ValidationGroup>
            </form>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default CreateEditModal;
